"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    style: {
      width: Math.max(170, (_vm.listQuery.name ? _vm.listQuery.name.length * 9 : 0) + 40) + "px"
    },
    attrs: {
      "remote-method": _vm.fetchProductList,
      filterable: "",
      clearable: "",
      remote: "",
      "default-first-option": "",
      placeholder: _vm.$t("product.name")
    },
    on: {
      change: _vm.handleFilter
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onProductSearchEnter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.name,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "name", $$v);
      },
      expression: "listQuery.name"
    }
  }, _vm._l(_vm.productList, function (product) {
    return _c("el-option", {
      key: product.id,
      attrs: {
        value: product.name,
        label: product.name
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      "remote-method": _vm.fetchCategoryList,
      filterable: "",
      clearable: "",
      "default-first-option": "",
      remote: "",
      placeholder: "Search Category"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["category.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "category.id", $$v);
      },
      expression: "listQuery['category.id']"
    }
  }, _vm._l(_vm.categoryList, function (category) {
    return _c("el-option", {
      key: category.id,
      attrs: {
        value: category.id,
        label: category.parentId ? category.name + ` (${category.parent.name})` : category.name
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: _vm.$t("product.enabled"),
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "enabled", $$v);
      },
      expression: "listQuery.enabled"
    }
  }, _vm._l(_vm.enableTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.value,
        value: item.key
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.sort,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "sort", $$v);
      },
      expression: "listQuery.sort"
    }
  }, _vm._l(_vm.sortOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("div", {
    staticClass: "button-group"
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "info",
      size: "small",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _vm.isSuperAdminOrManager() ? _c("router-link", {
    attrs: {
      to: {
        path: "/product/add",
        query: _vm.$route.query
      }
    }
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "warning",
      size: "small",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " ")])], 1) : _vm._e(), _vm.isSuperAdmin() ? _c("router-link", {
    attrs: {
      to: "/product/import"
    }
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "info",
      size: "small",
      icon: "el-icon-upload2"
    }
  }, [_vm._v(" Import ")])], 1) : _vm._e()], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    ref: "eltable",
    staticClass: "responsive-table",
    attrs: {
      data: _vm.list,
      border: "",
      "highlight-current-row": "",
      "row-key": "id"
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      sortable: "custom",
      width: "70",
      align: "center",
      label: _vm.$t("table.id"),
      prop: "id",
      "class-name": "hidden-xs " + _vm.getSortClass("id"),
      "label-class-name": "hidden-xs"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "90",
      label: "Image",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.productsImage && scope.row.productsImage.length > 0 ? _c("el-image", {
          staticStyle: {
            width: "50px",
            height: "50px",
            "border-radius": "4px"
          },
          attrs: {
            src: `${scope.row.productsImage[0].image}-og`,
            "preview-src-list": [scope.row.productsImage[0].image + "-og"],
            fit: "cover"
          }
        }) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "180",
      label: "Product",
      prop: "name",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", {
          staticClass: "name-cell"
        }, [_c("enabled", {
          attrs: {
            disabled: !_vm.isSuperAdmin(),
            url: "/products/" + scope.row.id
          },
          model: {
            value: scope.row.enabled,
            callback: function ($$v) {
              _vm.$set(scope.row, "enabled", $$v);
            },
            expression: "scope.row.enabled"
          }
        }), _c("span", {
          staticClass: "truncate-text"
        }, [_vm._v(_vm._s(scope.row.name))])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "200",
      align: "center",
      label: "Category"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-select", {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: scope.row.updatingCategory,
            expression: "scope.row.updatingCategory"
          }],
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: "Select Category",
            size: "small",
            filterable: ""
          },
          on: {
            change: function ($event) {
              return _vm.updateProductCategory(scope.row);
            }
          },
          model: {
            value: scope.row.categoryId,
            callback: function ($$v) {
              _vm.$set(scope.row, "categoryId", $$v);
            },
            expression: "scope.row.categoryId"
          }
        }, _vm._l(_vm.allCategories, function (category) {
          return _c("el-option", {
            key: category.id,
            attrs: {
              value: category.id,
              label: category.parentId && category.parent ? category.name + ` (${category.parent.name})` : category.name
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "220",
      align: "center",
      label: "Tags",
      prop: "tags"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-select", {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: scope.row.updatingTags,
            expression: "scope.row.updatingTags"
          }],
          staticStyle: {
            width: "100%"
          },
          attrs: {
            multiple: "",
            filterable: "",
            "allow-create": "",
            "default-first-option": "",
            placeholder: "Add Tags",
            size: "small"
          },
          on: {
            change: function ($event) {
              return _vm.updateProductTags(scope.row);
            }
          },
          model: {
            value: scope.row.tagsArray,
            callback: function ($$v) {
              _vm.$set(scope.row, "tagsArray", $$v);
            },
            expression: "scope.row.tagsArray"
          }
        }, _vm._l(scope.row.tagsArray, function (tag) {
          return _c("el-option", {
            key: tag,
            attrs: {
              label: tag,
              value: tag
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: _vm.$t("table.actions"),
      width: "70",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: {
              path: "/product/edit/" + scope.row.id,
              query: _vm.$route.query
            }
          }
        }, [_c("el-button", {
          directives: [{
            name: "waves",
            rawName: "v-waves"
          }],
          attrs: {
            type: "warning",
            size: "mini",
            icon: "el-icon-edit",
            circle: ""
          }
        })], 1)];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;